/*
 * @Description: 
 * @Version: vue
 * @Author: hgbian
 * @Date: 2022-05-13 10:22:59
 * @LastEditors: hgbian
 * @LastEditTime: 2022-05-24 08:56:20
 * @FilePath: \vue-tree\src\router\index.js
 * Copyright (C) 2022 hgbian. All rights reserved.
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/pedigree',
  },
  {
    path: '/pedigree',
    name: 'pedigree',
    component: () => import(/* webpackChunkName: "pedigree" */ '../views/pedigree.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
